module.exports = __webpack_public_path__ + "img/sand-dune-decal-01.023272ed.png";